// src/communaute/MessagerieRoute.jsx
//
// Petit wrapper : branche MessageriePage sur react-router pour que
// « ouvrir un événement » (depuis un message partagé) redirige vers
// la fiche événement du dashboard créateur, et pour ouvrir directement
// une conversation quand on arrive depuis une notification
// (ex: navigate('/EspaceClient/messagerie', { state: { convInitialeId } })).

import { useLocation, useNavigate } from 'react-router-dom';
import MessageriePage from './MessageriePage';

export default function MessagerieRoute() {
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <MessageriePage
            convInitialeId={location.state?.convInitialeId ?? null}
            onOuvrirEvenement={(id) => navigate(`/EspaceClient/mesevents/view/${id}`)}
        />
    );
}